import {
  FrontendApostleSeasonInfo,
  useFrontendConfigContext
} from '@apeiron/config'
import { SeasonInfo } from '@apeiron/download'
import { createStrictContext, MayNull } from '@apeiron/temp'
import useGetCurrentSeason from '@src/hooks/graphql/useGetCurrentSeason'
import { ReactNode, useCallback } from 'react'
type ContextType = {
  seasonInfo: MayNull<SeasonInfo>
  currentApostleConfig: MayNull<FrontendApostleSeasonInfo>
}

const [ContextProvider, useSeasonContext] =
  createStrictContext<ContextType>('Season')

export { useSeasonContext }

export const SeasonProvider = (props: Props) => {
  const { children } = props

  const { config } = useFrontendConfigContext()

  const { data: seasonInfo } = useGetCurrentSeason()

  const getApostleConfig = useCallback(
    (seasonId: string): FrontendApostleSeasonInfo => {
      const season = config?.apostleMintConfig.find(
        config => config.season === seasonId
      ) as FrontendApostleSeasonInfo

      return season
    },
    [config?.apostleMintConfig]
  )

  const currentApostleConfig = getApostleConfig(seasonInfo?.id || '')

  return (
    <ContextProvider value={{ seasonInfo, currentApostleConfig }}>
      {children}
    </ContextProvider>
  )
}

export type Props = {
  children: ReactNode
}
